import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function fileKind(mime) {
    if (mime === 'application/pdf')
        return 'pdf';
    if (mime === 'application/msword' ||
        mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
        return 'word';
    return 'unknown';
}
export function FileTypeIcon({ mime, className = 'h-9 w-9' }) {
    const kind = fileKind(mime);
    const fill = kind === 'pdf' ? '#DC2626' : kind === 'word' ? '#2563EB' : '#6B7280';
    const label = kind === 'pdf' ? 'PDF' : kind === 'word' ? 'DOC' : 'FILE';
    return (_jsxs("svg", { viewBox: "0 0 32 40", className: className, "aria-hidden": "true", children: [_jsx("path", { d: "M4 0h16l8 8v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Z", fill: fill, opacity: "0.12" }), _jsx("path", { d: "M4 0h16l8 8v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Z", fill: "none", stroke: fill, strokeWidth: "1.5" }), _jsx("path", { d: "M20 0v8h8", fill: "none", stroke: fill, strokeWidth: "1.5" }), _jsx("text", { x: "16", y: "29", textAnchor: "middle", fontFamily: "system-ui, sans-serif", fontSize: "9", fontWeight: "700", fill: fill, children: label })] }));
}
export function fileExtension(mime, fallback) {
    if (mime === 'application/pdf')
        return 'PDF';
    if (mime === 'application/msword')
        return 'DOC';
    if (mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
        return 'DOCX';
    return fallback ?? 'FILE';
}
export function fileTypeColor(mime) {
    if (mime === 'application/pdf')
        return { bg: '#FEE2E2', fg: '#991B1B' };
    if (mime === 'application/msword' ||
        mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
        return { bg: '#DBEAFE', fg: '#1E40AF' };
    return { bg: '#F3F4F6', fg: '#374151' };
}
//# sourceMappingURL=FileTypeIcon.js.map